'use strict'

import Modal from './Modal'

import './Modal.less'

export {
  Modal
}




// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Modal/index.js